import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';

import ZolaItem from './ZolaColumnItem';
import ExtraFieldsMenu from './ExtraFieldsMenu';

const ZolaColumnList = ({ addExtraField, extras, fields, maxHeight, unmapZolaColumn }) => {
  const handleDrop = item => {
    const { assignment, name: zolaCol } = item;
    if (assignment !== null) unmapZolaColumn(assignment, zolaCol);
  };
  const [, dropRef] = useDrop({
    accept: 'ZOLA_COL',
    drop: item => handleDrop(item),
  });
  const columns = Object.keys(fields);
  const style = { maxHeight };

  return (
    <div className="zola-list" style={style}>
      <div className="zola-list__title title">Our List</div>
      <div className="zola-list__container" ref={el => dropRef(el)}>
        {columns.map((colName, i) => {
          const { name, assignment } = fields[colName];
          return <ZolaItem fieldName={name} key={name + i} assignment={assignment} />;
        })}
        {extras.length > 0 && <ExtraFieldsMenu fields={extras} onExtraSelect={addExtraField} />}
      </div>
    </div>
  );
};

ZolaColumnList.propTypes = {
  addExtraField: PropTypes.func,
  extras: PropTypes.arrayOf(PropTypes.string),
  fields: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      assigned: PropTypes.bool,
    })
  ).isRequired,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unmapZolaColumn: PropTypes.func,
};

export default ZolaColumnList;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/ZolaColumnList.jsx